<script setup lang="ts">
interface Props {
  color?: 'default' | 'green'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'default'
})

const colorClasses = {
  default: 'border-[#f4b88c]',
  green: 'border-[#66c489]'
}

const backgroundStyles = {
  default: 'linear-gradient(90deg, rgba(66, 56, 54, 0) 0%, rgba(244, 184, 140, 0.4) 100%)',
  green: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(102, 196, 137, 0.3) 100%)'
}

const pillClasses = computed(() => [
  'flex items-center justify-center relative px-2 py-1 rounded-full border backdrop-blur-sm',
  '@3xl/main:px-4 @3xl/main:py-2',
  colorClasses[props.color]
])
</script>

<template>
  <div
    :class="pillClasses"
    :style="{ background: backgroundStyles[props.color] }"
  >
    <div class="relative z-20 text-xs @3xl/main:text-lg font-normal text-current text-center whitespace-nowrap">
      <slot />
    </div>
  </div>
</template>
